module.exports = __webpack_public_path__ + "static/img/TJCJmqRw.19aae08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/horse-nest/TJCJmqRw.jpg
// module id = Q/Fi
// module chunks = 7